import { render, staticRenderFns } from "./bigMetarialItem.vue?vue&type=template&id=667fc3d4&scoped=true"
import script from "./bigMetarialItem.vue?vue&type=script&lang=js"
export * from "./bigMetarialItem.vue?vue&type=script&lang=js"
import style0 from "./bigMetarialItem.vue?vue&type=style&index=0&id=667fc3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667fc3d4",
  null
  
)

export default component.exports